import "./main.css";

import ApiWebSocketCtxProvider from "@/context/provider";
import * as Sentry from "@sentry/react";
import ReactDOM from "react-dom/client";

import App from "./App.tsx";
import { Toaster } from "./components/ui/toaster.tsx";

Sentry.init({
  dsn: "https://e3683a29b90337f51c41b42e9dad02b1@o4507724843712512.ingest.de.sentry.io/4507724846596176",
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration(),
  ],
  // Performance Monitoring
  tracesSampleRate: 1.0, //  Capture 100% of the transactions
  // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
  tracePropagationTargets: ["localhost", /^https:\/\/ledgernalysis\.io\/api/],
  // Session Replay
  replaysSessionSampleRate: 0.5, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
  replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
});

ReactDOM.createRoot(document.getElementById("root")!).render(
  <ApiWebSocketCtxProvider>
      <App />
    <Toaster />
  </ApiWebSocketCtxProvider>
);
